import { ChangeEvent, FC, HTMLInputTypeAttribute } from "react"
import { NumericFormat } from "react-number-format"

export type InputFieldProps = {
  /**
   * Content to be appended to the end of the input value
   */
  suffix?: string
  /**
   * Component id
   */
  id: string
  /**
   * Text to be used as label and placeholder
   */
  label: string
  /**
   * Indicates if input field should be read only
   */
  readOnly?: boolean
  /**
   * Input type
   */
  type?: HTMLInputTypeAttribute
  /**
   * Input value
   */
  value: any
  /**
   * Minimum possible value to assign to the input
   */
  min?: any
  /**
   * Maximum possible value to assign to the input
   */
  max?: any
  error?: string
  touched?: boolean
  /**
   * Function to call when input value changes
   */
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const InputField: FC<InputFieldProps> = ({
  suffix = "",
  id,
  label,
  readOnly = false,
  type = "text",
  value,
  min = null,
  max = null,
  error = "",
  touched = false,
  handleChange = () => {},
}) => {
  return (
    <div className="mx-auto w-full max-w-sm">
      <label
        htmlFor={id}
        className="block text-sm px-3 font-medium text-semibold text-gray-700"
      >
        {label}
      </label>
      <div className="mt-1">
        {type === "number" ? (
          <NumericFormat
            id={id}
            name={id}
            placeholder={label}
            readOnly={readOnly}
            value={value}
            className="block w-full h-10 rounded-md border-0 py-2 px-3 text-left shadow-lg transition focus:border-brand-light focus:ring-brand-light sm:text-sm"
            onChange={handleChange}
            suffix={suffix}
            decimalScale={3}
          />
        ) : (
          <input
            id={id}
            name={id}
            type={type}
            placeholder={label}
            readOnly={readOnly}
            value={value}
            min={min}
            max={max}
            className="block w-full h-10 rounded-md border-0 py-2 px-3 text-left shadow-lg transition focus:border-brand-light focus:ring-brand-light sm:text-sm"
            onChange={handleChange}
          />
        )}

        {touched && error && <span className="text-red-500">{error}</span>}
      </div>
    </div>
  )
}
